<template>
  <div>
    <section-title
      class="mt-3"
      content="Datos del Padre, Madre o Tutor"
      has-line
    />

    <div class="row my-3">
      <info-field
        class="col-4"
        label="Nombre Padre, Madre o Tutor:"
        :value="model.tutor"
      />
      <info-field
        class="col-4"
        label="Parentesco:"
        :value="model.relationship"
      />
      <info-field
        class="col-4"
        format-type="phone"
        label="Teléfono:"
        :value="model.phoneNumber"
      />
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/shared/components/SectionTitle.vue';
import InfoField from './InfoField.vue';

export default {
  name: 'GuardianInfoSection',
  components: {
    SectionTitle,
    InfoField,
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
};
</script>
